import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { AgGrid, Spinner } from '../../../../components'
import { getDefaultColumnDef, preventDefaultRowClick, THEMES } from '../../../../utils'

import CustomCellRender from './cell/cell.component'

/**
 * Contact List Component
 */
class ContactListComponent extends PureComponent {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        { ...getDefaultColumnDef(0), field: '_id', headerName: 'Record ID', minWidth: 220, maxWidth: 220, pinned: 'left', lockPinned: true },
        { ...getDefaultColumnDef(1), field: 'status', headerName: 'Status', minWidth: 100,  maxWidth: 100, pinned: 'left', lockPinned: true },
        { ...getDefaultColumnDef(2, 'text'), field: 'full_name', headerName: 'Name', minWidth: 260,  maxWidth: 260, pinned: 'left', lockPinned: true },
        // regular columns with alternating styles
        { ...getDefaultColumnDef(3, 'text'), field: 'nickname', headerName: 'Nickname', minWidth: 180, maxWidth: 220 },
        { ...getDefaultColumnDef(4, 'text'), field: 'institution', headerName: 'Institution', minWidth: 180 },
        { ...getDefaultColumnDef(5, 'text'), field: 'title', headerName: 'Title', minWidth: 180 },
        { ...getDefaultColumnDef(6, 'text'), field: 'functions', headerName: 'Function(s)', minWidth: 180 },
        //{ ...getDefaultColumnDef(7), field: 'source', headerName: 'Source', minWidth: 100, maxWidth: 100 },
        { ...getDefaultColumnDef(7, 'date'), field: 'updated_date', headerName: 'Updated', minWidth: 90, maxWidth: 110 }
      ]
    }
  }

  /**
   * Handle AgGrid onGridReady event
   * @param grid
   * @see: {@link: https://github.com/ag-grid/ag-grid/issues/997}
   */
  handleGridReady = (grid) => {
    setTimeout(() => this.agGrid = grid, 0)
  }

  /**
   * Handle AgGrid gridSizeChanged event
   * @param type - event type
   */
  handleGridResize = ({ type }) => {
    if (type === 'gridSizeChanged') {
      setTimeout(() => this.agGrid && this.agGrid.api.sizeColumnsToFit(), 0)
    }
  }

  /**
   * Handle row click event
   * @param _id {String} - activity id
   */
  handleRowClicked = ({ _id }) => {
    _id && this.props.history.push(`/contact/${_id}`)
  }

  /**
   * Renders CustomCell Component
   */
  renderCustomCell = (props) => {
    return (<CustomCellRender {...props} />)
  }

  /**
   * Returns grid columns
   */
  getColumnsDefinition = () => {
    return this.state.columns.map(({ typeOfValue, ...column }, idx) => ({
      ...getDefaultColumnDef(idx, typeOfValue),
      ...column
    }))
  }

  /**
   * Render Contact Grid
   * @return {XML}
   */
  render () {
    const { data, total, filters: { page, limit }, loading, isGridReady, handleFilterChange } = this.props

    return (
      <>
        {loading && <Spinner mask theme={THEMES.RAIN} />}
        {isGridReady && (
          <AgGrid
            className='contacts-grid_list'
            domLayout='autoHeight'
            sizeToFit={true}

            // suppress configs
            suppressMovableColumns={true}
            suppressContextMenu={true}

            // columns and data
            defaultColDef={{
              suppressMenu: true,
              sortable: false,
              cellRenderer: 'CustomCellRender'
            }}
            columnDefs={this.getColumnsDefinition()}
            rowData={data}

            // pagination
            pagination={true}
            paginationProps={{
              pageSizeId: 'contact-list',
              forcePage: page,
              initialPageSize: limit,
              showPageSizeSelection: true,
              total,
              onPageChange: ({ selected }) => handleFilterChange({ page: selected }),
              onPageSizeChange: ({ selected }) => handleFilterChange({ page: 1, limit: selected })
            }}

            // custom components
            frameworkComponents={{
              CustomCellRender: this.renderCustomCell
            }}

            // event listeners
            onGridReady={this.handleGridReady}
            onGridSizeChanged={this.handleGridResize}
            onRowClicked={preventDefaultRowClick(this.handleRowClicked)}

            isPinned={data && data.length}
          />
        )}
      </>
    )
  }
}

ContactListComponent.propTypes = {
  isGridReady: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,

  data: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    status: PropTypes.string,
    full_name: PropTypes.string,
  })).isRequired,

  filters: PropTypes.shape({
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired
  }).isRequired,

  total: PropTypes.number.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
}

ContactListComponent.defaultProps = {
  data: [],
  total: 0,
  filter: {
    page: 1,
    limit: 10
  }
}

export default ContactListComponent